import './MSSidebar.css';
import { MSIcon } from './MSIcon';

export class MSSidebar {

    constructor(iConfig, $iContainer) {
        this.m_cfig = iConfig;
        this.$m_container = $iContainer;
        this.$m_element = this.$create(iConfig);
        this.$m_element.appendTo($iContainer);

        this.m_uid = ms_uid();
    }

    toggle() {
        if (this.$m_element.hasClass("toggled")) {
            this.$m_element.removeClass("toggled");
        } else {
            this.$m_element.addClass("toggled");
        }
    }

    $create(iConfig) {
        throw new Error("MSSidebar is abstract class");
    }
}

MSSidebar.create = function(iConfig) {
    let obj;
    switch (iConfig.style) {
        default : obj = new MSSidebarAccordion(iConfig); break;
    }
    return obj.$create(iConfig);
}

export class MSSidebarAccordion extends MSSidebar {

    $create(iConfig) {
        const $ul = $("<ul/>").addClass("sidebar_accordion navbar-nav");
        if (iConfig.class) {
            $ul.addClass(iConfig.class);
        }

        iConfig.items.forEach((item) => {
            this.$create_item(item).appendTo($ul);
        });

        return $ul;
    }

    $create_item(iItem) {
        // console.log(iItem)
        const collapse_id = "collapse_" + ms_uid();
        let $li = $("<li/>").addClass("nav-item sidebar_item");
        if (iItem.id) {
            $li.attr('item_id', iItem.id);
        }
        if (iItem.class) {
            $li.addClass(iItem.class); // Ajout des classes personnalisées
        }
        if(iItem.order){
            $li.css({"order":iItem.order})
        }else{
            $li.css({"order":"999"})
        }
        const $wrap = $("<div/>").addClass("wrap").appendTo($li);
        let $link;
        if (iItem.items && typeof (iItem.items) == "object") {
            $link = $("<a/>").addClass("link btn-toggle").attr({ "data-bs-toggle": "collapse", "href": "#" + collapse_id, "aria-expanded": false }).appendTo($wrap);
        } else {
            $link = $("<a/>").attr({ "id": "link_" + iItem.href }).addClass("autoclose link").appendTo($wrap);
            if (iItem.href) {
                $link.attr("href", iItem.href);
            }
            if(iItem.target){
                $link.attr("target", iItem.target);
            }
        }
        if (iItem.icon) {
            if(iItem.icon.indexOf("https")>=0){
                var $icon=$("<img/>").addClass("icon icon_svg").attr({"src":iItem.icon}).appendTo($link);
            }else{
                MSIcon.$(iItem.icon).appendTo($link);
            }
        }
        if (iItem.text) {
            $("<span/>").addClass("text").text(iItem.text).appendTo($link);
        }

        // Ajout de la balise <div>
        // if (iItem.divContent) {
        //     $("<div/>").addClass("custom-div").html(iItem.divContent).appendTo($li);
        // }

        if (typeof (iItem.items) == "object") {
            const $collapse = $("<div/>").addClass("collapse").attr({ "id": collapse_id }).appendTo($wrap);
            const $ul_collapse = $("<ul/>").addClass("list-group btn-toggle-nav").appendTo($collapse);
            for (const i in iItem.items) {
                this.$create_sub_item(iItem.items[i]).appendTo($ul_collapse);
            }
        }
        return $li;
    }

    $create_sub_item(iItem) {
        const $li = $("<li/>").addClass("collapse-item sidebar_sub_item");
        if (iItem.class) {
            $li.addClass(iItem.class); // Ajout des classes personnalisées
        }
        const $link = $("<a/>").attr({ "id": "link_" + iItem.href }).addClass("autoclose collapse-link").appendTo($li);
        if (iItem.href) {
            $link.attr("href", iItem.href);
        }
        if(iItem.target){
            $link.attr("target", iItem.target);
        }
        if (iItem.icon) {
            MSIcon.$(iItem.icon).appendTo($link);
        }
        if (iItem.text) {
            $("<span/>").addClass("collapse-text").text(iItem.text).appendTo($link);
        }
        return $li;
    }
}
